import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Header = ({ profile, onSelectTab }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [showAppBanner, setShowAppBanner] = useState(true);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    
    // 1. Thêm State cho thông báo sắp ra mắt
    const [showComingSoon, setShowComingSoon] = useState(false);

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = "/";
    };

    // 2. Hàm xử lý khi nhấn Tải App
    const handleDownloadClick = (e) => {
        e.preventDefault(); // Ngăn chặn chuyển hướng trang
        setShowComingSoon(true);
    };

    const menuItems = [
        { title: "Trang chủ", tabId: "HOME", icon: <i className="fa-solid fa-house"></i> },
        profile ? { title: "Thành viên", path: "/profile", icon: <i className="fa-solid fa-user"></i> } : null,
        !profile ? { title: "Đăng nhập", path: "/login", icon: <i className="fa-solid fa-right-to-bracket"></i> } : null,
        !profile ? { title: "Đăng ký", path: "/register", icon: <i className="fa-solid fa-user-plus"></i> } : null,
        { title: "Thể Thao", tabId: "SPORTS", icon: <i className="fa-solid fa-futbol"></i> },
        { title: "Sòng Bài", tabId: "CASINO", icon: <i className="fa-solid fa-dice"></i> },
        { title: "Nổ Hũ", tabId: "SLOTS", icon: <i className="fa-solid fa-basketball"></i> }, 
        { title: "Trò Chơi", tabId: "NUMBER", icon: <i className="fa-solid fa-8"></i> },
        { title: "Bắn Cá", tabId: "FISHING", icon: <i className="fa-solid fa-fish"></i> },
        { title: "Xổ số", tabId: "LOTTERY", icon: <i className="fa-solid fa-coins"></i> },
        { title: "Poker", tabId: "POKER", icon: <i className="fa-solid fa-diamond"></i> },
        { title: "Chọi gà", tabId: "COCKFIGHT", icon: <i className="fa-solid fa-kiwi-bird"></i> },
        { title: "Khuyến mãi", path: "/notification", icon: <i className="fa-solid fa-gift"></i> },
       { 
    title: "Liên Hệ", 
    path: "https://secure.livechatinc.com/licence/19707399/v2/open_chat.cgi", 
    icon: <i className="fa-solid fa-phone"></i>,
    target: "_blank" // <-- Thêm cái này
},
        profile ? { title: "ĐĂNG XUẤT", action: handleLogout, icon: <i className="fa-solid fa-arrow-right-from-bracket"></i> } : null,
    ].filter(Boolean);

   const handleMenuClick = (item) => {
        setIsSidebarOpen(false);
        
        if (item.action) {
            item.action();
        } else if (item.tabId) {
            if (location.pathname === '/' && onSelectTab) {
                onSelectTab(item.tabId);
            } else {
                navigate("/", { state: { activeTab: item.tabId } });
            }
        } else if (item.path) {
            // Kiểm tra xem path có phải là link bên ngoài không
            if (item.path.startsWith("http")) {
                window.open(item.path, "_blank"); // Mở link ngoài ở tab mới
            } else {
                navigate(item.path); // Chuyển trang nội bộ bằng React Router
            }
        }
    };

    return (
        <>
            <style>{`
                .app-banner { display: flex; align-items: center; justify-content: space-between; background-color: #e8e8e8; padding: 8px 12px; }
                .app-banner-left { display: flex; align-items: center; gap: 12px; }
                .app-banner-logo { width: 38px; height: 38px; border-radius: 6px; }
                .app-banner-info h5 { margin: 0; font-size: 16px; font-weight: bold; color: #004d99; }
                .app-banner-info span { margin: 0; font-size: 11px; color: #444; }
                .app-banner-btn { background-color: #333; color: #fff; text-decoration: none; padding: 6px 14px; border-radius: 20px; font-size: 12px; font-weight: bold; transition: 0.3s; }
                .app-banner-btn:active { background-color: #555; }
                
                /* CSS CHO THÔNG BÁO XỊN */
                .modal-overlay { position: fixed; top:0; left:0; right:0; bottom:0; background: rgba(0,0,0,0.7); display: flex; align-items: center; justify-content: center; z-index: 200000; backdrop-filter: blur(4px); }
                .custom-modal { background: #fff; width: 85%; max-width: 320px; border-radius: 15px; overflow: hidden; text-align: center; animation: zoomIn 0.3s ease; box-shadow: 0 10px 25px rgba(0,0,0,0.2); }
                .modal-header-img { background: #f8f9fa; padding: 20px; border-bottom: 1px solid #eee; }
                .modal-header-img i { font-size: 50px; color: #e03232; }
                .modal-body { padding: 20px; }
                .modal-body h4 { margin: 0 0 10px; color: #333; font-size: 18px; }
                .modal-body p { margin: 0; color: #666; font-size: 14px; line-height: 1.5; }
                .modal-footer { padding: 15px; border-top: 1px solid #eee; }
                .btn-close-modal { background: #e03232; color: #fff; border: none; padding: 10px 30px; border-radius: 25px; font-weight: bold; cursor: pointer; width: 100%; }

                @keyframes zoomIn {
                    from { opacity: 0; transform: scale(0.8); }
                    to { opacity: 1; transform: scale(1); }
                }

                .main-header { background: linear-gradient(90deg, #f7d4d4 0%, #e03232 50%, #f7d4d4 100%); height: 55px; display: flex; justify-content: space-between; align-items: center; padding: 0 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); position: relative; }
                .header-logo-center { position: absolute; left: 50%; transform: translateX(-50%); }
                .header-logo-center img { height: 50px; object-fit: contain; }
                .menu-btn { cursor: pointer; display: flex; align-items: center; justify-content: center; }
                .sidebar-backdrop { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 100000; }
                .sidebar-drawer { position: fixed; top: 0; left: 0; bottom: 0; width: 270px; background-color: #888888; z-index: 100001; transform: translateX(-100%); transition: transform 0.3s ease-in-out; overflow-y: auto; box-shadow: 2px 0 8px rgba(0,0,0,0.3); }
                .sidebar-drawer.open { transform: translateX(0); }
                .sidebar-title { background: #b71c1c; color: #fff; font-size: 16px; font-weight: bold; text-align: center; padding: 18px; text-transform: uppercase; }
                .sidebar-list { list-style: none; margin: 0; padding: 0; }
                .sidebar-list li { border-bottom: 1px solid #999; }
                .sidebar-list li div { display: flex; align-items: center; padding: 12px 20px; color: #fff; font-size: 14px; font-weight: 500; cursor: pointer; }
                .sidebar-icon { color: #eac15a; margin-right: 15px; display: flex; align-items: center; width: 20px; justify-content: center; }
            `}</style>

            {/* POPUP THÔNG BÁO XỊN */}
            {showComingSoon && (
                <div className="modal-overlay" onClick={() => setShowComingSoon(false)}>
                    <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header-img">
                            <i className="fa-solid fa-rocket animate__animated animate__bounce"></i>
                        </div>
                        <div className="modal-body">
                            <h4>Sắp Ra Mắt!</h4>
                            <p>Ứng dụng KIMSA dành riêng cho di động đang được hoàn thiện những bước cuối cùng. Vui lòng quay lại sau!</p>
                        </div>
                        <div className="modal-footer">
                            <button className="btn-close-modal" onClick={() => setShowComingSoon(false)}>ĐÃ HIỂU</button>
                        </div>
                    </div>
                </div>
            )}

            {showAppBanner && (
                <div className="app-banner">
                    <div className="app-banner-left">
                        <i className="fa-solid fa-xmark" onClick={() => setShowAppBanner(false)} style={{ fontSize: "20px", color: "#333", cursor: "pointer", marginRight: "5px" }}></i>
                        <img className="app-banner-logo" src="https://dztwieyphe62d.cloudfront.net/content/images/app/icon/kimsa.png?v=1.1" alt="App Logo" />
                        <div className="app-banner-info">
                            <h5>KIMSA</h5>
                            <span>Fast, efficient and reliable app to use.</span>
                        </div>
                    </div>
                    {/* 3. Đổi href sang xử lý onClick */}
                    <a href="/" onClick={handleDownloadClick} className="app-banner-btn">TẢI XUỐNG</a>
                </div>
            )}

            <div className="main-header">
                <div className="menu-btn" onClick={() => setIsSidebarOpen(true)}>
                    <i className="fa-solid fa-bars" style={{ fontSize: "28px", color: "#000" }}></i>
                </div>
                <div className="header-logo-center">
                    <Link to="/"><img src="https://dztwieyphe62d.cloudfront.net/content/images/logo/logo-sandsvn.png" alt="KIMSA Logo" /></Link>
                </div>
                <div style={{ width: "32px" }}></div>
            </div>

            {isSidebarOpen && <div className="sidebar-backdrop" onClick={() => setIsSidebarOpen(false)}></div>}
            
            <div className={`sidebar-drawer ${isSidebarOpen ? 'open' : ''}`}>
                <div className="sidebar-title">THỰC ĐƠN</div>
                <ul className="sidebar-list">
                    {menuItems.map((item, index) => (
                        <li key={index}>
                            <div onClick={() => handleMenuClick(item)}>
                                <span className="sidebar-icon">{item.icon}</span>
                                {item.title}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default Header;